module.exports = [{
      plugin: require('/Users/danieldavidson/Desktop/new_wedding/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/danieldavidson/Desktop/new_wedding/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
